<template>
  <div>
    <div class="pc_header_box clearfix_">
      <div class="fl pc_header_logo">
        <router-link v-show="logoType==1" :to="{name:'home'}"><img :src="logoPic" height="60"/></router-link>
        <router-link class="pc_header_logo_txt" v-show="logoType==2" :to="{name:'home'}"><span class="pc_header_logo_txt1">{{logo1}} </span> <span class="pc_header_logo_txt2"> {{logo2}}</span></router-link>
      </div>
      <div class="fl pc_header_search">
        <div class="pc_header_search_input_box">
          <div><input @input="matching" :placeholder="defaultTxt" v-model="msgcontent" @keyup.13.stop="GoGoodsList" class="pc_header_search_input" type="text"></div>
          <div @click="GoGoodsList($event,msgcontent)" class="pc_header_search_input_search"></div>
          <div v-show="msgcontent&&historytxt.length>0&&historytxt!==undefined&&historytxt!==null" class="pc_header_search_input_search_list">
            <div v-for="(item,index) in historytxt" :key="index" @click="hostlistclick(item.id)" class="pc_header_search_input_search_item">{{item.name}}</div>
          </div>
        </div>
        <div class="pc_header_search_hot_list clearfix_">
          <div @click="goto(index,item.status,searchHot)" :key="index" v-for=" (item,index) in searchHot" class="pc_header_search_hot_item fl clearfix_">
            <div class="fl pc_header_search_hot_item_txt">{{item.title}}</div>
            <div class="fl pc_header_search_hot_item_modification">|</div>
          </div>
        </div>
      </div>
      <div class="fl pc_header_hearder_right_list clearfix_">
        <div @click="goto(index,item.status,rightList)" v-for=" (item,index) in rightList" :key="index" class="pc_header_hearder_right_item fl clearfix_">
          <div class="pc_header_hearder_right_item_img fl"><img :src="item.pic" alt=""></div>
          <div class="pc_header_hearder_right_item_txt fl">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div class="pc_home_nav_box">
      <div class="pc_home_nav clearfix_">
        <div v-show="categoryLv1.length>0&&categoryLv1!==undefined&&categoryLv1!==null" class="fl pc_home_nav_category clearfix_">
          <div class="fl pc_home_nav_category_img"></div>
          <div @mouseenter="categoryLv1ShowFn" class="fl pc_home_nav_category_txt">全部商品分类</div>
          <div v-show="categoryLv1Show"  @mouseenter="categoryLv1ShowFn"  @mouseleave="categoryLv2HideFn"class="pc_home_nav_category_lv1">
            <div @mouseenter="categoryLv2ShowFn(item.id,$event)" @mouseleave="categoryLv2HideFn" @click="goToGoodsList(item.id)" v-for="(item,index) in categoryLv1" :key="index" class="pc_home_nav_category_lv1_item clearfix_">
              <div class="fl pc_home_nav_category_lv1_item_txt">{{item.name}}</div>
              <div class="fr pc_home_nav_category_lv1_item_img"><img src="../../assets/img/arrow.png" alt=""></div>
            </div>
          </div>
          <div v-show="categoryLv2Show" class="level_2" @mouseenter="categoryLv3ShowFn" @mouseleave="categoryLv3HideFn">
            <ul v-show="levelNum==2" class="level_2_ul">
              <li class="level_2_ul_li" v-for="(item,index) in categoryLv2" :key="index"><b @click="goToGoodsList(item.id)">{{item.name}}</b></li>
            </ul>
            <ul v-show="levelNum==3" class="level_3_ul">
              <li class="level_3_ul_li clearfix_" v-for="(item,index) in categoryLv2" :key="index">
                <div class="fl level_3_ul_li_title clearfix_">
                  <b @click="goToGoodsList(item.id)" :title="item.name">{{item.name}}</b>
                </div>
                <ul style="width:780px;" class="level_3_ul_li_ul fl clearfix">
                  <li  @click="goToGoodsList(val.id)" class="level_3_ul_li_li fl" v-for="(val,idx) in item.categorys" :key="idx">{{val.name}}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="fl pc_home_nav_list clearfix_">
          <div class="fl pc_home_nav_item"><router-link :to="{name:'home'}">首页</router-link></div>
          <div @click="goto(index,item.status,navData)" v-for="(item,index) in navData" :key="index" class="fl pc_home_nav_item">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import Qs from 'qs'
    import { ip,overtime } from '../../assets/js/public.js'
    export default {
        name: "search",
        inject:['reload'],
        data () {
          return {
            logoPic:'',
            logo1:'',
            logo2:'',
            msgcontent:"",
            historytxt:[],
            historystatus:false,
            pagesize:20,
            page:1,
            defaultTxt:'',
            logoType:'',
            levelNum:0,
            categoryLv1:[],
            categoryLv2:[],
            categoryLv1Show:false,
            categoryLv2Show:false,
            navData:[],
            rightList:[],
            searchHot:[]
          }
        },
        computed:{

        },
        mounted () {
          var t_ = this;
          var allData=JSON.parse(localStorage.getItem('indexAllData'))
          allData.forEach(function(item,index){
            if(item.parentName=='nav')t_.navData=item.content
            if(item.parentName=='headerRight')t_.rightList=item.content
            if(item.parentName=='keyWord')t_.searchHot=item.content
          })
          var arr = window.localStorage.getItem("arr");
          t_.getLogo()
          t_.getCategory()
          if(t_.$route.query.txt)t_.msgcontent=t_.$route.query.txt
        },
        methods:{
          goSignIn:function(){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              name: 'loginHome',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
          },
          go404:function(msg){
            var href=this.$router.resolve({name:'err404',query:{txt:msg}})
            window.open(href.href,'_blank')
          },
          goToGoodsList:function (id) {
            var href=this.$router.resolve({name:'goodslist',query: {id: id}});
            window.open(href.href,'_blank')
          },
          categoryLv3HideFn:function(){
            this.categoryLv2Show = false
          },
          categoryLv2HideFn:function(){
            this.categoryLv1Show = false
            this.categoryLv2Show = false
          },
          categoryLv3ShowFn:function(){
            this.categoryLv1Show=true
            this.categoryLv2Show = true
          },
          categoryLv2ShowFn : function (id,event) {
            this.categoryLv1Show=true
            this.categoryLv2Show = true
            const url = `${ip}formWorkInterface/getCategoryByCategoryId`;
            let data = Qs.stringify({"channel":2,"id":id,tamp:localStorage.tamp?localStorage.tamp:''});
            axios.post(url,data)
              .then(res => {
                if(overtime(res.data.code))return t_.goSignIn()
                if(res.data.code==300)return t_.go404(res.data.message)
                this.categoryLv2 = res.data.categoryIds;
              }).catch(err => {
            })
          },
          categoryLv1ShowFn:function () {
            this.categoryLv1Show=true
          },
          getCategory:function () {
            var t_=this
            let data = Qs.stringify({"channel":2,tamp:localStorage.tamp?localStorage.tamp:'',AreaAlias:'category'})
            axios.post(`${ip}formWorkInterface/getCategory`,data).then(res=>{
              if(overtime(res.data.code))return t_.goSignIn()
              if(res.data.code==300)return t_.go404(res.data.message)
              t_.categoryLv1 = res.data.categoryIds
              t_.levelNum=res.data.level
            })
          },
          goto:function(idx,status,obj){
            var t_ = this
            if( status==1 ){
              if(obj[idx].atriceId=='')return
              var href=this.$router.resolve({
                name:'articleList',
                query:{
                  id:obj[idx].atriceId
                }
              })
              window.open(href.href,'_blank')
            }else if(status==2){
              var href=this.$router.resolve({
                name:'goodslist',
                query: {
                  id: obj[idx].categoryId
                }
              })
              window.open(href.href,'_blank')
            }else if(status==3){
              var href=this.$router.resolve({
                name:'goodslist',
                query: {
                  txt: obj[idx].search
                }
              })
              window.open(href.href,'_blank')
            }else if(status==5){
              window.open(obj[idx].link)
            }else if(status==6){
              var href=t_.$router.resolve({
                  name:'goodsdetails',
                  query:{
                    goodsId:obj[idx].goodsId,
                    isSupplyChainGoods:2,
                    supplyChainTenantId:obj[idx].supplyChainTenantId
                  }
                })
              window.open(href.href,'_blank')
            }else if(status==4){
              var href=t_.$router.resolve({
                name:obj[idx].formwordPcLocal,
                query:{
                  id:obj[idx].formwordId
                }
              })
              window.open(href.href,'_blank')
            }else if(status==9){
              if(obj[idx].module==1){
                var href=this.$router.resolve({name:'teamGoods'});
                window.open(href.href,'_blank')
              }else if(obj[idx].module==3){
                var href=this.$router.resolve({name:'couponList'});
                window.open(href.href,'_blank')
              }else if(obj[idx].module==5){
                var href=this.$router.resolve({name:'activityList'});
                window.open(href.href,'_blank')
              }else if(obj[idx].module==6){
                var href=this.$router.resolve({name:'scoreChange'});
                window.open(href.href,'_blank')
              }
            }
          },
          getLogo:function(){
            var t_=this
            var data0bj = Qs.stringify({
              channel:2,
              tamp:localStorage.tamp?localStorage.tamp:''
            })
            axios.post(`${ip}formWorkInterface/getTenantLogo`,data0bj).then(res=>{
              if(res.data.code==300)return t_.go404(res.data.message)
              if(res.data.code!=0)return
              // t_.$store.commit('getTenantLogo',res.data)
              localStorage.setItem('tenantLogo',JSON.stringify(res.data))
              t_.logoType=res.data.logoType
              t_.logoPic=res.data.logo
              t_.logo1=res.data.logo2
              t_.logo2=res.data.logo3
            })
          },
          hostlistclick:function(id){
            var href=this.$router.resolve({name:'goodslist',query: {id:id}})
            window.open(href.href,'_blank')
          },
          matching:function(){
            if(!this.msgcontent)return this.historystatus=false
            this.historystatus=true
            var data0bj = Qs.stringify({
              channel:2,
              name:this.msgcontent
            })
            axios.post(`${ip}formWorkInterface/fuzzyCategory`,data0bj).then(res=>{
              if(res.data.code==300)return t_.go404(res.data.message)
              if(res.data.code!=0)return
              this.historytxt=res.data.data
            })
          },
          GoGoodsList : function () {
            var href=this.$router.resolve({name:'goodslist',query: {txt:this.msgcontent?this.msgcontent:this.defaultTxt}})
            window.open(href.href,'_blank')
          },
        }
    }
</script>

<style>
  .pc_header_box{
    width: 1200px;
    height: 130px;
    margin: 0 auto;
    background: #fff;
  }
  .pc_header_logo{
    width: 275px;
    height: 60px;
    margin-top: 35px;
    text-align: center;
  }
  .pc_header_logo_txt1{
    font-size: 30px;
    color: #fb0;
    margin-right: 10px;
  }
  .pc_header_logo_txt2{
    font-size: 20px;
  }
  .pc_header_logo_txt{
    line-height: 60px;
  }
  .pc_header_search{
    width: 450px;
    margin: 0 50px;
    padding-top: 50px;
  }
  .pc_header_search_input_box{
    width: 445px;
    border: 1px solid #ccc;
    height: 35px;
    position: relative;
    margin-bottom: 15px;
  }
  .pc_header_search_input{
    padding-left: 10px;
    width: 435px;
    height: 35px;
  }
  .pc_header_search_input_search{
    width: 37px;
    height: 27px;
    background: url(/static/img/elves.f13544c.png) no-repeat -89px -445px;
    position: absolute;
    top:5px;
    right:10px;
    cursor: pointer;
  }
  .pc_header_search_input_search_list{
    width: 445px;
    border: 1px solid #ccc;
    border-top: 0;
    position: absolute;
    left: -1px;
    top: 36px;
    background: #fff;
  }
  .pc_header_search_input_search_item{
    padding: 10px;
    cursor: pointer;
  }
  .pc_header_search_input_search_item:hover{
    background: #FFDFC6;
  }
  .pc_header_search_hot_list{
    width: 445px;
  }
  .pc_header_search_hot_item{
    cursor: pointer;
    color: #ccc;
  }
  .pc_header_search_hot_item_txt{
    padding-right: 8px;
  }
  .pc_header_search_hot_item_modification{
    margin-top: -1px;
    margin-right: 8px;
  }
  .pc_header_search_hot_item:last-child .pc_header_search_hot_item_modification{
    display: none;
  }
  .pc_header_hearder_right_list{
    width: 375px;
    padding-top: 45px;
  }
  .pc_header_hearder_right_item{
    width: 33.3%;
    height: 30px;
    cursor: pointer;
  }
  .pc_header_hearder_right_item_img{
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .pc_header_hearder_right_item_img img{
    width: 30px;
    height: 30px;
  }
  .pc_header_hearder_right_item_txt{
    line-height: 30px;
  }
  .pc_home_nav_box{
    width: 100%;
    height: 50px;
    background: #fa0;
  }
  .pc_home_nav{
    width: 1200px;
    margin: 0 auto;
  }
  .pc_home_nav_category{
    width: 241px;
    height: 50px;
    cursor: pointer;
    position: relative;
  }
  .pc_home_nav_category_img{
    width: 15px;
    height: 12px;
    background: url(../../assets/img/biaoqian.png);
    margin: 20px 38px 0 27px;
  }
  .pc_home_nav_category_txt{
    font-size: 16px;
    color: #fff;
    line-height: 50px;
  }
  .pc_home_nav_category_lv1{
    width: 241px;
    background: rgba(133,80,62,.8);
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 9;
  }
  .pc_home_nav_category_lv1_item{
    height: 40px;
    cursor: pointer;
  }
  .pc_home_nav_category_lv1_item_txt{
    color: #fff;
    font-family: '微软雅黑';
    padding-left: 50px;
    line-height: 40px;
  }
  .pc_home_nav_category_lv1_item_img{
    width: 15px;
    height: 15px;
    margin-top: 13px;
    margin-right: 35px;
  }
  .pc_home_nav_category_lv1_item_img img{
    width: 15px;
    height: 15px;
  }
  .pc_home_nav_list{
    margin-left: 67px;
    width: 790px;
    height: 50px;
  }
  .pc_home_nav_item{
    padding: 0 35px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
  }
  .level_2{
    float: left;
    width: 900px;
    position: absolute;
    left: 241px;
    top: 50px;
    z-index: 999;
    background: white;
    min-height: 540px;
  }
  .level_2_ul_li{
    font-size: 12px;
    padding: 15px 20px;
    cursor: pointer;
    line-height: 1;
  }
  .level_2_ul_li>b{
    color:#333;
  }
  .level_2_ul_li>b:hover{
    color:#fa0;
  }
  .level_3_ul_li_title{
    width: 100px;
  }
  .level_3_ul_li_title b{
    color:rgba(133,80,62,1);
    display: block;
    width: 85px;
    text-align: center;
    padding: 14px 0;
    font-size: 12px;
    line-height: 1;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    cursor: default;
    font-weight: 900;
    margin: 0 auto;
  }
  .level_3_ul_li_title i{
    width:15px;
    height: 15px;
    margin-top:15px;
  }
  .level_3_ul_li_title i img{
    width:15px;
    height: 15px;
  }
  .level_3_ul_li_li{
    color:#333;
    padding: 15px 20px;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
  }
  .level_3_ul_li_li:hover{
    color:#fa0;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/search.vue